export function DashboardLayout() {
  return (
    <div className="flex flex-col gap-2 max-w-3xl">
      <h1 className="text-2xl font-semibold">Dashboard</h1>
      <p className="text-muted-foreground text-sm">
        Welcome to the SUL AI admin portal.
      </p>
    </div>
  )
}
